import * as React from "react";

interface IRangeInputProps {
    id: string;
    value?: number;
    onChange: (value: number) => void;
}

/* use 'checked' only for 'controlled' component, when state is managed by it`s parent  */
/* use 'defaultChecked' only for 'uncontrolled' component, when state is not managed by parent */
/* https://github.com/facebook/react/issues/13477#issuecomment-416003818 */

export const OpacityControl = ({ id, value, onChange }: IRangeInputProps): JSX.Element => {
    const percents = Math.round(value * 100);
    const left = percents + "%";
    return (
        <div className="sliderContainer">
            <div className="sliderInnerContainer">
                <label className="settings-toggle-label" htmlFor={id}>
                    <div className="percentage-container">
                        <span style={{ left }}>{left}</span>
                    </div>
                </label>
                <div className="switch">
                    <input /* controlled input */
                        type="range"
                        id={id}
                        key={id}
                        min="0"
                        max="1"
                        step="0.01"
                        value={value}
                        onChange={(e) => onChange(Number(e.target.value))}
                        data-testid={id}
                    />

                    <label htmlFor={id} className="range-label"></label>
                </div>
            </div>
        </div>
    );
};
